import React, { Component, Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'

import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'zone-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const columns = [
  {
    title: 'Client Id',
    dataIndex: 'clientId',
    sorter: (a, b) => a.clientId.localeCompare(b.clientId)
  },
  {
    title: 'Site Id',
    dataIndex: 'siteId',
    sorter: (a, b) => a.siteId.localeCompare(b.siteId)
  },
  {
    title: 'Zone Id',
    dataIndex: 'zoneId',
    render: (name, row) => (
      <Link to={ROUTES.ZONE_EDIT.replace(':siteId', row.siteId).replace(':zoneId', row.zoneId).replace(':targetClientId', row.clientId)}>
        {name}
      </Link>
    ),
    sorter: (a, b) => a.zoneId.localeCompare(b.zoneId)
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name)
  },
  {
    title: 'Description',
    dataIndex: 'description',
    sorter: (a, b) => a.description.localeCompare(b.description)
  }
]

const ListViewZones = ({ zones }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {zones.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {zones.length} zones
      </PageContentUnderTitle>
    )}
    <Table dataSource={zones} columns={columns} pagination={false} rowKey={"clientId"+"zoneId"} />
  </div>
)

export default ListViewZones



// WEBPACK FOOTER //
// ./src/pages/summary/summary-list/components/list-view-zones/index.js